/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IFilterPikNewbuildingsResponseSchema } from '../../entities/schemas/FilterPikNewbuildingsResponseSchema';

export type TFilterPikNewbuildingsModel = IModel<IFilterPikNewbuildingsRequest, TFilterPikNewbuildingsResponse>;

export interface IFilterPikNewbuildingsRequest {
  /** Год сдачи **/
  buildYear?: number | null;
  /** Есть ли сданные объекты **/
  handOver?: boolean | null;
  /** С отделкой **/
  hasDecoration?: boolean | null;
  /** ID локации **/
  location?: number | null;
  /** Цена до **/
  priceMax?: number | null;
  /** Цена от **/
  priceMin?: number | null;
  /** Комнатность квартир **/
  room?: ERoom[] | null;
  /** Площадь до **/
  totalAreaMax?: number | null;
  /** Площадь от **/
  totalAreaMin?: number | null;
}

export type TFilterPikNewbuildingsResponse = IFilterPikNewbuildingsResponse200 | IFilterPikNewbuildingsResponse400;

export interface IFilterPikNewbuildingsResponse200 extends IModelResponse<IFilterPikNewbuildingsResponse> {
  statusCode: 200;
}

export interface IFilterPikNewbuildingsResponse400 extends IModelResponse<IFilterPikNewbuildingsResponseError> {
  statusCode: 400;
}

export interface IFilterPikNewbuildingsResponse {
  data: IFilterPikNewbuildingsResponseSchema;
  status: EStatus;
}

export interface IFilterPikNewbuildingsResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IFilterPikNewbuildingsResponse | IFilterPikNewbuildingsResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export enum ERoom {
  /** Койко-место **/
  Bed = 'bed',
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Комната **/
  Room = 'room',
  /** Доля в квартире **/
  Share = 'share',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IFilterPikNewbuildingsResponse): TResponse200;
  400(response: IFilterPikNewbuildingsResponseError): TResponse400;
}
